const EnumAssuntoManifestacao = {
    DENUNCIA: 1,
    RECLAMACAO: 2,
    ELOGIO: 3,
    SUGESTAO: 4,
    PEDIDO_INFORMACAO: 5,
    1: "Denúncia",
    2: "Reclamação",
    3: "Elogio",
    4: "Sugestão",
    5: "Pedido de Informação",
}

export default EnumAssuntoManifestacao